export function getCarInfoByNumber(number) {
  return axios.get('/api/directories/car/' + number)
}
